export default __webpack_public_path__ + "static/media/european_commission.739df2c5.svg";